/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Viewings_Report_TotalInputs */

const cs_viewings_report_total = /** @type {(inputs: Viewings_Report_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Celkem: ${i?.n}`)
};

const en_viewings_report_total = /** @type {(inputs: Viewings_Report_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Total: ${i?.n}`)
};

/**
* | output |
* | --- |
* | "Total: {n}" |
*
* @param {Viewings_Report_TotalInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const viewings_report_total = /** @type {((inputs: Viewings_Report_TotalInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewings_Report_TotalInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewings_report_total(inputs)
	return cs_viewings_report_total(inputs)
});